<template>
    <div class="container container--breadcrumb">
        <ul class="gh-breadcrumb">
            <li class="gh-breadcrumb__item">
                <span class="gh-breadcrumb__item__inner"><router-link :to="homeRoute">{{ homeLabel }}</router-link></span>
                <span class="gh-breadcrumb__separator">{{ separator }}</span>
            </li>

            <slot></slot>
        </ul>
    </div>
</template>

<script>
    import ghBreadcrumbItem from './breadcrumbItem.vue';

    export default {
        components: {ghBreadcrumbItem},
        
        props: {
            homeRoute: {
                type: String,
                default: '/'
            },

            homeLabel: {
                type: String,
                default: 'Home'
            },

            separator: {
                type: String,
                default: '>'
            }
        }
    }
</script>